import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { NarrativeTemplates } from 'components/Settings/Components/NarrativeTemplates/components/NarrativeTemplates/narrativeTemplates';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const NarrativeTemplatesPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.narrativeTemplates.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.narrativeTemplates.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <NarrativeTemplates />
            </MainContent>
        </PageContainer>
    );
};
